class HomeNewIn extends HTMLElement {
  constructor() {
    super();

    this.handleIntersection = this.handleIntersection.bind(this);
    this.observer = new IntersectionObserver(this.handleIntersection, {
      root: null, // Use the viewport as the root
      threshold: 0.1, // Trigger when 10% of the element is visible
    });
  }

  connectedCallback() {
    this.observer.observe(this); // Start observing the <home-new-in> element
  }

  disconnectedCallback() {
    this.observer.unobserve(this); // Stop observing when the element is removed
  }

  handleIntersection(entries, observer) {
    entries.forEach(entry => {
      const productsElement = this.querySelector('.home-new-in__products');
      if (!productsElement) return; // Exit if the element is not found

      if (entry.isIntersecting) {
        productsElement.classList.add('enable-animation');
      } else {
        productsElement.classList.remove('enable-animation');
      }
    });
  }
}

customElements.define('home-new-in', HomeNewIn);
